module.exports = __webpack_public_path__ + "static/media/user.a1dcf194.png";